import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SlideImage from './Image';
import SlideTitle from './Title';
import SlideParagraph from './Paragraph';

/**
 * Slide
 *
 * This component is in charge of displaying
 * a slide
 *
 * @param {node} children // Anything that can be rendered: numbers, strings, elements or an array (or fragment).
 * @param {string} className // className needed by styled components.
 *
 * @return {jsx}
 */

export const Slide = ({ className, children }) => <div className={className}>{children}</div>;

Slide.Image = SlideImage;
Slide.Title = SlideTitle;
Slide.Paragraph = SlideParagraph;

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Slide.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Slide.defaultProps = {
  className: '',
  children: null,
};

export default styled(Slide)`
  min-width: 100%;
  height: 100%;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/Slide/index.js